import { useQuery } from '@tanstack/react-query';

import AppTokensService, { AppToken } from '@/services/AppTokensService';

export const GET_APP_TOKENS_QUERY_KEY = ['app-tokens'];
export function useGetAppTokens() {
  const { data, isFetching } = useQuery<AppToken[]>({
    queryKey: GET_APP_TOKENS_QUERY_KEY,
    queryFn: () => AppTokensService.getAppTokens(),
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  const sortedAppTokens = (data ?? [])
    .slice()
    .sort(
      (a, b) =>
        new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
    );

  return {
    appTokens: sortedAppTokens,
    appTokensLoading: isFetching,
  };
}
